import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { InputType } from '../../enums/inpuTypeEnum';
import { KeyEventListener } from '@usimweb/core/services';

@Component({
    selector: 'usimweb-form-input',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './form-input.component.html',
    styleUrls: ['./form-input.component.scss'],
    standalone: false
})
export class FormInputComponent extends KeyEventListener implements OnChanges {
  @Input() value: any = undefined;

  @Input() placeholder: string = '';

  @Input() type: InputType = InputType.CHARS;

  @Input() required: boolean = false;

  @Input() readonly: boolean = false;

  @Input() toolTipText: string = '';

  @Input() min: number = null as any;

  @Input() max: number = null as any;

  @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('inputRef') inputRef!: ElementRef;

  public max_chars = 40;

  constructor() {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['min']) {
      this.min = changes['min'].currentValue;
    }

    if (changes['max']) {
      this.max = changes['max'].currentValue;
    }
  }

  public selectionChanged(event: Event) {
    const valueStr = (event.target as HTMLTextAreaElement).value.toString();
    this.selectionChange.emit(valueStr);
    const value = parseFloat(valueStr);

    if (this.min || this.max) {
      if (value < this.min || value > this.max) {
        this.inputRef.nativeElement.value = null;
      }
    }
  }
}
